module.exports = __webpack_public_path__ + "img/sales.c9bb3cd6.svg";